import { DynamicsBcContactMatchField, DynamicsBcCustomerMatchField, DynamicsBcSettingsModuleProps } from '@src/pages/settings/types';
import React from 'react';
import { Row, Col, Form, FloatingLabel } from 'react-bootstrap';
import { DraggableList } from './draggableList';

export const CustomerContactPriorities: React.FC<DynamicsBcSettingsModuleProps> = ({ dynamicsBcUserDefaultData, setDynamicsBcUserDefaultData }) => {
  const handleExistingCustomerUpdateToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!setDynamicsBcUserDefaultData) return;

    setDynamicsBcUserDefaultData({
      ...dynamicsBcUserDefaultData,
      update_existing_customers: event.target.checked,
    });
  };

  const handleExistingContactUpdateToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!setDynamicsBcUserDefaultData) return;

    setDynamicsBcUserDefaultData({
      ...dynamicsBcUserDefaultData,
      update_existing_contacts: event.target.checked,
    });
  };

  const handleCustomerMatchFieldChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (!setDynamicsBcUserDefaultData) return;

    setDynamicsBcUserDefaultData({
      ...dynamicsBcUserDefaultData,
      customer_match: event.target.value as DynamicsBcCustomerMatchField,
    });
  };

  const handleContactMatchFieldChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (!setDynamicsBcUserDefaultData) return;

    setDynamicsBcUserDefaultData({
      ...dynamicsBcUserDefaultData,
      contact_match: event.target.value as DynamicsBcContactMatchField,
    });
  };

  return (
    <>
      <Form.Group as={Row} className="mb-3" controlId="formHorizontalCustomerMatchField">
        <Form.Label column sm={6}>
          Specify which Rentman customer field to match against Dynamics Business Central customer number
        </Form.Label>
        <Col sm={6}>
          <FloatingLabel controlId="floatingSelectCustomerMatchField" label="Customer match field">
            <Form.Select aria-label="Customer match field" value={dynamicsBcUserDefaultData.customer_match || 'id'} onChange={handleCustomerMatchFieldChange}>
              <option value="id">ID</option>
              <option value="databaseNumber">Database Number</option>
              <option value="vat">VAT identification number</option>
              <option value="email">Email</option>
              <option value="email2">Email 2</option>
              <option value="phone">Phone</option>
              <option value="phone2">Phone 2</option>
            </Form.Select>
          </FloatingLabel>
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="mb-3" controlId="formHorizontalContactMatchField">
        <Form.Label column sm={6}>
          Specify which Rentman contact person field to match against Dynamics Business Central contact number
        </Form.Label>
        <Col sm={6}>
          <FloatingLabel controlId="floatingSelectContactMatchField" label="Contact match field">
            <Form.Select aria-label="Contact match field" value={dynamicsBcUserDefaultData.contact_match || 'id'} onChange={handleContactMatchFieldChange}>
              <option value="id">ID</option>
              <option value="email">Email</option>
              <option value="phone">Phone</option>
              <option value="mobilephone">Mobile phone</option>
            </Form.Select>
          </FloatingLabel>
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="mb-3" controlId="formHorizontalUpdateExistingCustomers">
        <Form.Label column sm={6}>
          Update existing customers in Dynamics Business Central
        </Form.Label>
        <Col sm={6}>
          <Form.Check
            type="switch"
            id="update-existing-customers-switch"
            label="Enable"
            checked={dynamicsBcUserDefaultData.update_existing_customers !== false}
            onChange={handleExistingCustomerUpdateToggle}
          />
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="mb-3" controlId="formHorizontalUpdateExistingContacts">
        <Form.Label column sm={6}>
          Update existing contacts in Dynamics Business Central
        </Form.Label>
        <Col sm={6}>
          <Form.Check
            type="switch"
            id="update-existing-contacts-switch"
            label="Enable"
            checked={dynamicsBcUserDefaultData.update_existing_contacts !== false}
            onChange={handleExistingContactUpdateToggle}
          />
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="mb-3" controlId="formHorizontalCustomerContactPriorities">
        <Form.Label column sm={6}>
          Drag items to prioritize which customer or company to use as customer contact, where the first item in the list has the highest priority
        </Form.Label>
        <Col sm={6}>
          <DraggableList dynamicsBcUserDefaultData={dynamicsBcUserDefaultData} setDynamicsBcUserDefaultData={setDynamicsBcUserDefaultData} />
        </Col>
      </Form.Group>
    </>
  );
};
